import InventoryListingSaveGlyph from './InventoryListingSaveGlyph';
export default InventoryListingSaveGlyph;